
    /**
    * Floor value to full steps.
    */
    function floor(val, step){
        step = Math.abs(step || 1);
        return Math.floor(val / step) * step;
    }
    module.exports = floor;




//////////////////
// WEBPACK FOOTER
// ./~/mout/math/floor.js
// module id = 1616
// module chunks = 0 1 2